const ES = {
    document: 'Documento',
    role: 'Rol',
    email: 'Correo',
    status: {
        1: 'Pendiente',
        2: 'Activo',
        3: 'Recupero',
        4: 'Bloqueado',
        5: 'Inactivo',
        9: 'Información',
        10: 'Información',
        11: 'En Revision',
        'admin.natura': 'Administrador',
        'operator.natura': 'Operador',
        'ext-support-operator.natura': 'Operador Externo',
        'fraud_prevention_analyst.natura': 'Operador de prevención de fraude',
        'fraud_prevention_admin.natura': 'Administrador de prevención de fraude',
        'user_admin.natura': 'Administrador de Usuarios',
        'customer.natura': 'Cliente'
    }
};

export default ES;
